import { render } from "./Home.vue?vue&type=template&id=209392b4&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=209392b4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-209392b4"

export default script